import { Card } from 'ui';
import { useScreenSizeObserver } from 'common/hooks';
import variables from 'common/styles/variables.json';

import { Greetings } from './greetings';
import { NavigationMenu } from './navigation-menu';

const Navigation = () => {
  const { screenWidth } = useScreenSizeObserver();
  const isCollapsed = screenWidth < variables.screenXl.value;

  return (
    <div className="app-navigation">
      <Card className="app-navigation__greetings" shrinked>
        <Greetings isCollapsed={isCollapsed} />
      </Card>
      <Card className="app-navigation__menu" marginBottom={false} shrinkedLeft shrinkedRight>
        <NavigationMenu isCollapsed={isCollapsed} />
      </Card>
    </div>
  );
};

export default Navigation;
